"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var _configCategotyEdit = _interopRequireDefault(require("@/views/maintain/devconfig/configCategotyEdit.vue"));
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
var _configList = _interopRequireDefault(require("./configList"));
var _formConfig = _interopRequireDefault(require("@/views/maintain/formConfig"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  // name: "configCategroy"
  components: {
    edit: _configCategotyEdit.default,
    configList: _configList.default,
    formConfigList: _formConfig.default
  },
  props: {},
  data: function data() {
    return {
      constants: this.$constants,
      searchPram: {
        status: null,
        type: null
      },
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建，1=编辑
        prent: {},
        // 父级对象
        data: {}
      },
      treeList: [],
      listPram: {
        pid: 0,
        type: this.$constants.categoryType[5].value,
        status: null,
        name: null,
        page: this.$constants.page.page,
        limit: this.$constants.page.limit[1]
      },
      configFormSelectedDialog: {
        visible: false,
        currentData: {}
      }
    };
  },
  mounted: function mounted() {
    this.handlerGetTreeList();
  },
  methods: {
    handlerOpenFormConfig: function handlerOpenFormConfig(rowData) {
      this.configFormSelectedDialog.currentData = rowData;
      this.configFormSelectedDialog.visible = true;
    },
    handlerGetList: function handlerGetList() {
      var _this = this;
      categoryApi.listCategroy(this.listPram).then(function (data) {
        // this.dataList = data
        _this.treeList = data;
      });
    },
    handlerOpenAdd: function handlerOpenAdd(rowData) {
      this.editDialogConfig.isCreate = 0;
      this.editDialogConfig.prent = rowData;
      this.editDialogConfig.data = {};
      this.editDialogConfig.biztype = this.biztype;
      this.editDialogConfig.visible = true;
    },
    handleEditMenu: function handleEditMenu(rowData) {
      this.editDialogConfig.isCreate = 1;
      this.editDialogConfig.data = rowData;
      this.editDialogConfig.prent = rowData;
      this.editDialogConfig.visible = true;
    },
    handleDelMenu: function handleDelMenu(rowData) {
      var _this2 = this;
      this.$modalSure('删除当前数据?').then(function () {
        categoryApi.deleteCategroy(rowData).then(function (data) {
          _this2.handlerGetTreeList();
          _this2.$message.success('删除成功');
        });
      });
    },
    hideEditDialog: function hideEditDialog() {
      var _this3 = this;
      setTimeout(function () {
        _this3.editDialogConfig.prent = {};
        _this3.editDialogConfig.type = 0;
        _this3.editDialogConfig.visible = false;
        _this3.handlerGetTreeList();
      }, 200);
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this4 = this;
      // status: this.selectModel?1:-1
      var _pram = {
        type: this.constants.categoryType[5].value,
        status: -1
      };
      categoryApi.treeCategroy(_pram).then(function (data) {
        _this4.treeList = _this4.handleAddArrt(data);
      });
    },
    handleAddArrt: function handleAddArrt(treeData) {
      // let _result = this.addTreeListLabel(treeData)
      var _result = selfUtil.addTreeListLabel(treeData);
      return _result;
    },
    handlerSelectedRowData: function handlerSelectedRowData(rowData) {
      this.configFormSelectedDialog.currentData.extra = rowData.id;
    },
    handlerAddFormExtra: function handlerAddFormExtra() {
      var _this5 = this;
      categoryApi.updateCategroy(this.configFormSelectedDialog.currentData).then(function (data) {
        _this5.$message.success('关联表单成功');
        setTimeout(function () {
          _this5.configFormSelectedDialog.visible = false;
          _this5.handlerGetTreeList();
        }, 800);
      });
    }
  }
};